import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable()
export class KycVerificationConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getKnowYourCustomerEndpoint(): string {
		return this.service.get((x) => x.common.payment.endpoints!.knowYourCustomer, "v1/kycuris/");
	}
}
